import { Button,  Container, Grid, Paper, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import React, { useCallback, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import FormProvider, {RHFCheckbox, RHFTextField, RHFTextFieldMUI} from './hook-form';
import { enqueueSnackbar } from 'notistack';
import axiosInstance, { API_ENDPOINTS } from '../axios/axiosInstance';
import { isDisabled } from '@testing-library/user-event/dist/utils';
import RHFDateTimePicker from './hook-form/rhf-datetime-picker';
import moment from 'moment/moment';
import SEO from './SEO';
import Turnstile from './Turnstile';

const Reserva = ({current}) => {
    const { t, i18n } = useTranslation();
    const [turnstileToken, setTurnstileToken] = useState(null);
    const reservationSchema = Yup.object().shape({
      fullName: Yup.string().required(t('reservations.requiredField')),
      email: Yup.string().required(t('reservations.requiredField')),
      phoneNumber: Yup.string().required(t('reservations.requiredField')),
      personsAmmount: Yup.string().required(t('reservations.requiredField')),
      date: Yup.string().required(t('reservations.requiredField')),
      notes: Yup.string().required(t('reservations.requiredField')),
      terms: Yup.bool().oneOf([true], t('reservations.requiredField'))
    });
    const defaultValues = useMemo(
      () => ({
        fullName: current?.fullName || '',
        email: current?.email || '',
        phoneNumber: current?.phoneNumber || '',
        personsAmmount: current?.personsAmmount || '',
        date: current?.date || '',
        notes: current?.notes || '',
        terms: current?.terms || false
      }),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [current]
    );
    const methods = useForm({
      resolver: yupResolver(reservationSchema),
      defaultValues,
    });
    
    const {
      setValue,
      reset,
      getValues,
      handleSubmit,
      formState: { isSubmitting },
    } = methods;
    
    const onSubmit = useCallback(
      async (data) => {
        try {
          if (!turnstileToken) {
            enqueueSnackbar(t('reservations.securityVerification'), { variant: 'error' });
            return;
          }

          const isoDate = moment(data.date).utc().toISOString();
          var objToSend = getValues();
          objToSend.date=isoDate;
          objToSend.language = i18n.language;
          objToSend.turnstileToken = turnstileToken;
          await axiosInstance.post(API_ENDPOINTS.reservation, objToSend);
          enqueueSnackbar(t('reservations.successMessage'),{
                      variant: 'success', // Exibe como sucesso
                      autoHideDuration: 12000, // Tempo maior para leitura
                      anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'center', // Centralizado na tela
                      },
                      style: {
                        maxWidth: '500px', // Largura maior
                        fontSize: "14px",
                        backgroundColor: '#4caf50', // Cor de fundo (verde sucesso)
                        color: 'white', // Texto branco
                        borderRadius: '8px', // Bordas arredondadas
                      },
                    });
          reset();
          setTurnstileToken(null);
        } catch (error) {
          console.error(error);
        }
      },
      [reset, getValues, turnstileToken, t]
    );

    const handleInputChange = (event) => {
      const inputValue = event.target.value;
      // Remove any non-numeric characters
      const numericValue = inputValue.replace(/[^0-9]/g, '');
      setValue('personsAmmount',numericValue);
    };
  return (
    <>
    <SEO
      titleKey="seo.reservationsTitle"
      descriptionKey="seo.reservationsDescription"
      path="/reservations"
    />
    <section className="banner " >
    <div id="menu-parallax">
      <div className="bcg background43 dark"
                data-center="background-position: 50% 0px;"
                data-anchor-target="#menu-parallax"
              >
        <div className="bg-transparent" style={{zIndex:99}}>
          <div className="banner-content">
            <div className="container" >
              <div className="slider-content  " style={{paddingTop:'160.5px'}}>
                <h1>{t('reservations.title')}</h1>
                <p>{t('reservations.subtitle')}</p>
                <ol className="breadcrumb">
                  <li><Link to='/'>{t('nav.home')}</Link></li>
                  <li>{t('reservations.breadcrumb')}</li>
                </ol>
  
              </div>
            </div>
          </div>
          
        </div>
        
      </div>
      <div >
          <section id="reservas" style={{position:'relative',zIndex:999,marginTop:'-185px'}}>
  <Container component="main" maxWidth="md" sx={{ mb: 1 }}>
        <Paper style={{backgroundColor:'white'}} sx={{ my: { xs: 2, md: 3 }, p: { xs: 2, md: 3 } }}>
  <React.Fragment>
      <Typography variant="h6" gutterBottom>
        {t('reservations.formTitle')}
      </Typography>
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <RHFTextField
            id="name"
            name="fullName"
            label={t('reservations.fullName')}
            fullWidth
            inputProps={{
                autoComplete: 'off'
             }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <RHFTextField
            id="email"
            name="email"
            label={t('reservations.email')}
            fullWidth
            inputProps={{
                autoComplete: 'off'
             }}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
        <RHFTextFieldMUI
        id="phonenumber"
        name="phoneNumber"
        label={t('reservations.phone')}
        fullWidth variant='outlined' autoFormat defaultCountry={'pt'} />

        </Grid>

        <Grid item xs={12} sm={3}>
          <RHFTextField
            type='text'
            name="personsAmmount"
            label={t('reservations.persons')}
            onChange={handleInputChange}
            fullWidth
            inputProps={{
                pattern: '[0-9]*', // For browser validation (not supported by all browsers)
                maxLength: 2,
              }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
            <RHFDateTimePicker
                slotProps={{ textField: { fullWidth: true } }}
                id="date"
                name="date"
                ampm={false}
                error={!!methods.formState.errors.date}
                helperText={methods.formState.errors.date?.message}
                  />
        </Grid>
        <Grid item xs={12} sm={12}>
          <RHFTextField

            id="notes"
            multiline
            name="notes"
            label={t('reservations.notes')}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} sm={12}>
          <Turnstile
            onVerify={(token) => setTurnstileToken(token)}
            onExpire={() => setTurnstileToken(null)}
          />
        </Grid>

        <Grid item xs={12} sm={9} className='primary-color'>
          <RHFCheckbox
            name="terms"
            label={
                <Typography style={{fontSize:'12px'}}>
       {t('reservations.terms')}{' '}
            <Link to="/terms-and-conditions" style={{fontWeight:'bold'}} className='active' target="_blank">
              {t('reservations.termsLink')}
            </Link>.
      </Typography>
      }
          />
        </Grid>
        <Grid item xs={12} sm={3} style={{textAlign:'right'}}>
        <Button fullWidth variant="contained" {...(isSubmitting && isDisabled)} disabled={isSubmitting || !turnstileToken} type='submit' className='white-color' size="large">{t('reservations.submit')}</Button>
        </Grid>
      </Grid>
      </FormProvider>
    </React.Fragment></Paper></Container>
  </section>
          </div>    </div>
  </section>
 
    </>
  );
};

export default Reserva;